export default "__VITE_ASSET__BYc9NY65__"